// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1xCgs","icon":"SortAdornment_icon__2WWpp","up":"SortAdornment_up__1JzuB","down":"SortAdornment_down__L2hbI","active":"SortAdornment_active__3BxYx"};